<!--历史值操作页面-->
<template>
	<div class="historyPageBody">
		<div class="historyFrom">
			<h1>添加一整天的历史值</h1>
			<el-form ref="historyFrom" :model="historyFrom" label-width="100px">
				<el-form-item label="变量类型">
					<el-input type="textarea" v-model="historyFrom.variableName" disabled></el-input>
				</el-form-item>
				<!--<el-form-item label="变量类型">
					<el-select v-model="appType" placeholder="请选择活动区域">
						<el-option label="水" value="水"></el-option>
						<el-option label="电" value="电"></el-option>
						<el-option label="气" value="气"></el-option>
					</el-select>
				</el-form-item>-->
				<el-form-item label="日期">
					<el-date-picker type="date" placeholder="选择日期" v-model="historyFrom.day" style="width: 100%;"></el-date-picker>
				</el-form-item>
				<el-form-item label="区间最小值">
					<el-input v-model="historyFrom.mini"></el-input>
				</el-form-item>
				<el-form-item label="区间最大值">
					<el-input v-model="historyFrom.max"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="onSubmit">确定修改</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				historyFrom: {
					variableName: '',
					day: new Date(),
					mini: 10,
					max: 1000,
				},
				appType:"电",
				typeNo:36,
				variableList: [], //所有的变量集合
				count: 0,

			}
		},
		created() {},
		mounted() {
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			appType(nv,ov){
				switch(nv) {
						case "电":
							this.typeNo = 36
							break;
						case "水":
							this.typeNo = 237
							break;
						case "气":
							this.typeNo = 361
							break;
					}
			}
		},
		methods: {
			AutomaticOnSubmit() {
				
			},
			initData() {
				if(isempty(this.nowUnit.id)) {
					return
				}
				this.variableList = []
				this.historyFrom.variableName = ""
				this.$api.areausePower.getFindAreausePiwerList(this.nowUnit.id,respon => {
					if(!isempty(respon)) {
						respon.forEach(item => {
							this.variableList.push(item.relatVariabel)
							this.historyFrom.variableName += item.relatVariabel + ','
						})
					}
				})
			},
			onSubmit() {
				//修改数据
				let sqlKey = []
				for(let i = 0; i < 24; i++) {
					for(let j = 0; j < 60; j += 5) {
						if(j < 10) {
							if(i < 10) {
								sqlKey.push("value" + 0 + "" + i + "" + 0 + "" + j)
							} else {
								sqlKey.push("value" + i + "" + 0 + "" + j)
							}
						} else {
							if(i < 10) {
								sqlKey.push("value" + 0 + "" + i + "" + j)
							} else {
								sqlKey.push("value" + i + "" + j)
							}
						}
					}
				}
				//计算出值的数组
				let sqlValue = []
				let increase = parseFloat((this.historyFrom.max - this.historyFrom.mini) / 288)
				let count = parseFloat(this.historyFrom.mini)
				for(let i = 0; i < 288; i++) {
					count += increase
					sqlValue.push(count.toFixed(2))
				}
				//组合sql
				let sql = "UPDATE historyex" + this.historyFrom.day.format('yyyyMM')
				let sql2 = " SET  "
				sqlKey.forEach((item, index) => {
					if(index + 1 < sqlKey.length) {
						sql2 += item + "=" + sqlValue[index] + ","
					} else {
						sql2 += item + "=" + sqlValue[index]
					}

				})
				this.variableList.forEach(item => {
					let sqltj = " WHERE day=" + this.historyFrom.day.format('dd') + " AND variablename=" + "'" + item + "'"
					let apiSql = sql + sql2 + sqltj
					this.$api.testApi.historyValueSql(apiSql, respon => {
						this.$message(respon)
					})
				})
			},
			getMath(index) {
				//生成随机数
				let count = ""
				for(let i = 0; i < index; i++) {
					count += Math.round(Math.random() * 10)
				}
				return count
			},
		    
		},
	}
</script>

<style scoped>
	.historyPageBody {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
	
	.historyFrom {
		width: 100%;
		height: 100%;
	}
	
	.historyPageBody h1 {
		font-size: .18rem;
		line-height: .5rem;
		padding-left: 20%;
	}
	
</style>
<style>
	.historyPageBody .el-form {
		display: flex;
		align-items: center;
	}
</style>